import { Loading } from '@liveauctioneers/hammer-ui-core/loading';
import { BankAccountOnFile } from '@liveauctioneers/hammer-ui-payments/checkout';
import { useEffect } from 'react';

import { BankAccountSelection } from '@/components/PaymentMethodSelection/BankAccountSelection';
import { LaPlaidLink } from '@/components/Plaid/LaPlaidLink';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { fetchBankAccountsIfNeeded } from '@/redux/modules/account/payments/bankAccount/bankAccount.actions';
import {
    getBankAccounts,
    getBankAccountsLoaded,
    getBankAccountsLoading,
} from '@/redux/modules/account/payments/bankAccount/bankAccount.selectors';
import { BankAccount } from '@/types/bankAccount';
import { formatBankAccountTitle } from '@/utils/bankAccount';

type Props = {
    active: boolean;
    isSelected: boolean;
    onBankAccountSelectionChange: (bankAccount: BankAccount) => void;
    selectedBankAccount: BankAccount;
};

export const PaymentMethodAchSelection = ({
    active,
    isSelected,
    onBankAccountSelectionChange,
    selectedBankAccount,
}: Props) => {
    const dispatch = useAppDispatch();

    const bankAccountsLoaded = useAppSelector(getBankAccountsLoaded);
    const bankAccounts = useAppSelector(getBankAccounts);
    const bankAccountsLoading = useAppSelector(getBankAccountsLoading);

    useEffect(() => {
        if (!bankAccountsLoaded) {
            dispatch(fetchBankAccountsIfNeeded());
        }
    }, [dispatch, bankAccountsLoaded]);

    if (!isSelected) {
        return null;
    }

    if (!active) {
        return selectedBankAccount && <BankAccountOnFile title={formatBankAccountTitle(selectedBankAccount)} />;
    }

    return (
        <>
            {bankAccountsLoading ? (
                <Loading />
            ) : (
                <BankAccountSelection
                    bankAccounts={bankAccounts}
                    selectBankAccount={(bankAccount: BankAccount) => {
                        onBankAccountSelectionChange(bankAccount);
                    }}
                />
            )}
            <div className="smMax:mb-lg">
                <LaPlaidLink useTextStyle />
            </div>
        </>
    );
};
